import { wrapRequest } from '@applandeo/api-wrapper';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ALERT_VARIANT, useAlertMessages } from '@/components/Global/AlertMessages/AlertMessagesProvider';
import { getUserData } from '@/dataExchange/services/user.service';
import { ExtendedUserData } from '@/domain/common';
import { useSentryActions } from '@/sentry/hooks/useSentryActions';
import { SENTRY_ACTIONS } from '@/sentry/sentryActions';

const useQueriedUserData = () => {
    const getUserDataWrapper = wrapRequest(getUserData);
    const { pathname } = useLocation();
    const credentialId = pathname.substring(pathname.lastIndexOf('/') + 1);

    const { createAlert } = useAlertMessages();
    const { t } = useTranslation();
    const { handleSentryAction } = useSentryActions();

    const [userData, setUserData] = useState<ExtendedUserData>();

    const getUserInfo = () => {
        getUserDataWrapper
            .fetch({ credentialId })
            .onSuccess(setUserData)
            .onAnyError(error => {
                createAlert(ALERT_VARIANT.error, t('newRequest_alerts_failed_get_user_data'));
                handleSentryAction(error, SENTRY_ACTIONS.ERROR_GET_USER_DATA);
            });
    };

    useEffect(() => {
        if (!credentialId) return;
        getUserInfo();
    }, [credentialId]);

    return {
        queriedCredentialId: credentialId,
        queriedUsername: userData?.username,
        queriedUserFullName: `${userData?.firstName ?? ''} ${userData?.lastName ?? ''}`,
    };
};

export default useQueriedUserData;
